import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import './App.css';
import DraggerFiles from './Postdata/DraggerFiles';
import DisplayResult from './Respose/DisplayResult';

function App(props) {
  console.log('app-props', props);
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path='/' exact element={<DraggerFiles />} />
          <Route path='uploadfilesAlysisResult' element={<DisplayResult />} />
        </Routes>
      </Router>
    </div >
  );
}

export default App;
